import { Link } from 'react-router-dom';
import Logo from './Logo';

const footerCols = [
  {
    title: 'Tài khoản',
    links: [
      { label: 'Đăng nhập', to: '/dang-nhap' },
      { label: 'Hồ sơ', to: '/ho-so' },
      { label: 'Xác minh danh tính', to: '/xac-minh-danh-tinh' },
      { label: 'Ngân hàng', to: '/ngan-hang' },
    ],
  },
  {
    title: 'Hỗ trợ',
    links: [
      { label: 'Trung tâm hỗ trợ', to: '/lien-he' },
      { label: 'Trung tâm thông báo', to: '/thong-bao' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200/60 bg-background-100">
      <div className="mx-auto px-4 md:px-6 py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
        <div className="lg:col-span-2">
          <Logo />
          <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-sm">
            Nền tảng theo dõi và giao dịch vàng trực tuyến hàng đầu Việt Nam. Giá vàng cập nhật liên tục, giao dịch minh bạch và an toàn.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a href="#" rel="nofollow" className="w-9 h-9 rounded-md bg-background-200 flex items-center justify-center text-foreground-600 hover:text-primary-400 cursor-pointer transition-colors">
              <i className="ri-facebook-line text-lg"></i>
            </a>
            <a href="#" rel="nofollow" className="w-9 h-9 rounded-md bg-background-200 flex items-center justify-center text-foreground-600 hover:text-primary-400 cursor-pointer transition-colors">
              <i className="ri-youtube-line text-lg"></i>
            </a>
            <a href="#" rel="nofollow" className="w-9 h-9 rounded-md bg-background-200 flex items-center justify-center text-foreground-600 hover:text-primary-400 cursor-pointer transition-colors">
              <i className="ri-telegram-line text-lg"></i>
            </a>
          </div>
        </div>

        {footerCols.map((col) => (
          <div key={col.title}>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">{col.title}</h4>
            <ul className="space-y-3">
              {col.links.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-300 cursor-pointer transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-background-200/60">
        <div className="mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">© 2026 Goldsbvvn. Bảo lưu mọi quyền.</p>
          <p className="text-xs text-foreground-600">Cảnh báo rủi ro: Giao dịch vàng có thể mang lại rủi ro về giá trị tài sản.</p>
        </div>
      </div>
    </footer>
  );
}